import { useState, useRef, useEffect } from 'react'
import Typography from '@mui/material/Typography'
import { Box, Button } from '@mui/material'
import { ButtonCustom } from '../../components/Button/ButtonCustom'
import { useStyles } from './style'
import { useParams } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import { seriesEvents, deleteSeries } from '../../services/EventService'

import { EventList } from './EventList'
import { flexcol } from '../../global'
import AddNewSeriesEvent from './AddNewSeriesEvent'
import AddNewSeriesEventCast from './eventCast/AddNewSeriesEvent'
import moment from 'moment'
import { convertMinutesIntoTime } from '../../services/Helper'
import { CustomDialog } from '../../components/CustomDialog'
import { EventType } from '../../services/Types'
import { SelectEventType } from '../../components/SelectEventType/SelectEventType'

const SeriesEvents = ({
  isSerialEvent,
  setSerialEvent,
  setSerialEvents,
  setLoadingSeries,
  makeSeriesEvent,
  saveMainBooking,
  removeSerialEvent,
  eventType
}: {
  isSerialEvent: boolean
  setSerialEvent: any
  setSerialEvents: any
  setLoadingSeries: any,
  makeSeriesEvent: any
  saveMainBooking: any
  removeSerialEvent: any
  eventType: string
}) => {
  const classes = useStyles()

  let { id } = useParams()
  const eventListRef = useRef<any>(null)
  const [openAddEvent, setOpenAddEvent] = useState(false)
  const [deleteSeriesDialog, setDeleteSeriesDialog] = useState(false)
  const [eventTypeSelected, setEventTypeSelected] = useState(EventType.WEBINAR)

  const childRef = useRef<any>(null)
  const [events, setEvents] = useState<any>([])

  const getSeriesEvents = async (eventId: number) => {
    try {
      const { data } = await seriesEvents(eventId)
      if (data) {
        if (data.seriesEvents.statusCode === 200) {
          if (data.seriesEvents.data.length > 1) {
            setSerialEvent(true)
          }
          let allBookingData: any[] = []
          data.seriesEvents.data.forEach((value: any) => {
            let event: any = {
              id: value.id,
              title: value.title,
              start: '',
              startTime: '',
              eventType: value.eventType
            }

            if (value.roomBooking.length > 0) {
              let booking = value.roomBooking[0]
              const eventDate = Number(booking.date)
              event.start = moment
                .utc(new Date(eventDate))
                .format('MMMM Do YYYY')
              event.startTime = convertMinutesIntoTime(booking.startTime)
            }

            if (event.eventType !== EventType.SERIES) {
              allBookingData.push(event)
            }
          })
          setEvents(allBookingData)
          setSerialEvents(data.seriesEvents.data
            .filter((event: any) => event.eventType !== EventType.SERIES))
          setLoadingSeries(false)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleAddNewEvent = () => {
    setOpenAddEvent(true)
    childRef.current.updateEvent({})
  }

  const updateSeriesEvents = () => {
    eventListRef.current.updateSeriesList()
  }

  const openDeleteSeriesDialog = () => {
    if (isSerialEvent) {
      setDeleteSeriesDialog(true)
    }
  }

  const showSeriesEvent = () => {
    if (!isSerialEvent) {
      makeSeriesEvent(setSerialEvent)
    }
  }

  useEffect(() => {
    getSeriesEvents(Number(id))
  }, [openAddEvent])

  const handleDelete = () => {
    deleteSeries(Number(id))

    setSerialEvent(false)
    setSerialEvents([])
    setDeleteSeriesDialog(false)
  }

  return (
    <>
      {/* Is this event part of a series?*/}
      <Grid item sm={12}>
        <Box className={classes.eventTitle} sx={{ maxWidth: '100%' }}>
          <Typography align='left' variant='h5'>
            Is this event part of a series?
          </Typography>
        </Box>
      </Grid>

      <Grid
        item
        sm={12}
        container
        sx={{
          gridAutoFlow: 'row',
          justifyContent: {
            xs: 'center',
            sm: 'space-between',
            md: 'space-between',
            lg: 'space-between'
          },

          gridRowGap: '2rem'
        }}
      >
        <Box className={classes.datepickerWrapper}>
          <Button
            onClick={() => showSeriesEvent()}
            style={{
              backgroundColor: isSerialEvent ? '#333333' : '#EBEAEC',
              color: isSerialEvent ? '#ffffff' : '#333333',
              width: '94px',
              borderRadius: '100px',
              textTransform: 'none',
              fontSize: '14px !important',
              marginRight: '8px'
            }}
          >
            Yes
          </Button>

          <Button
            onClick={() => {
              // console.log('[Hari Debug]', events.length > 1)
              if (events.length > 1) {
                openDeleteSeriesDialog()
              }else{
                setSerialEvent(false)
              }
            }}
            style={{
              backgroundColor: !isSerialEvent ? '#333333' : '#EBEAEC',
              color: !isSerialEvent ? '#ffffff' : '#333333',
              width: '94px',
              borderRadius: '100px',
              textTransform: 'none',
              fontSize: '14px !important'
            }}
          >
            No
          </Button>
        </Box>
        <Box sx={{ width: '425px' }}>
          <Typography
            sx={{
              fontSize: '16px !important',
              fontWeight: '400',
              lineHeight: '24px',
              letter: '2%',
              textAlign: 'left',
              color: '#79747E'
            }}
          >
            An event series consists of two or more related events. Select this
            option if you plan on conducting a multi-part event.
          </Typography>
        </Box>
      </Grid>

      {isSerialEvent && (
        <Grid>
          <Grid item sm={12} sx={{ marginBottom: '32px' }}>
            <Box className={classes.eventTitle} sx={{ maxWidth: '100%' }}>
              <Typography
                align='left'
                fontSize='23px !important'
                fontWeight='700'
              >
                Add events to your series below
              </Typography>
            </Box>
          </Grid>

          <Box style={flexcol}>
            <EventList ref={eventListRef} saveMainBooking={saveMainBooking} removeSerialEvent={removeSerialEvent} />

            <Box
              sx={{
                marginTop: '20px',
                width: '430px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end'
              }}
            >
              <SelectEventType
                value={eventTypeSelected}
                excludedEventTypes={[EventType.SERIES, EventType.BLOCKED]}
                onChange={(eventType: string) => {
                  setEventTypeSelected(eventType as EventType)
                  console.log('eventTypeSelected', eventType)
                }}
              />
              <ButtonCustom
                onClick={() => handleAddNewEvent()}
                backgroundColor='#333333'
                color='#FFFFFF'
                label={'Add Another Event Date'}
                sx={{ mr: '0px' }}
              />
            </Box>
          </Box>
        </Grid>
      )}

      <CustomDialog
        title='Are you sure you want to delete this series events?'
        primaryButtonText='Yes, delete'
        secondaryButtonText='Cancel'
        open={deleteSeriesDialog}
        onClose={() => setDeleteSeriesDialog(false)}
        onPrimaryButtonClick={handleDelete}
        onSecondaryButtonClick={() => setDeleteSeriesDialog(false)}
      />

      {/* Add Event Dialog Box */}

      {eventTypeSelected === EventType.WEBINAR ? (
      <AddNewSeriesEvent
        ref={childRef}
        updateSeriesEvents={updateSeriesEvents}
        seriesFirstEventId={Number(id)}
        openAddEvent={openAddEvent}
        setOpenAddEvent={setOpenAddEvent}
        index={events.length + 1}
        eventType={eventTypeSelected}
        ></AddNewSeriesEvent>
      ) : (
        <AddNewSeriesEventCast
          ref={childRef}
          updateSeriesEvents={updateSeriesEvents}
          seriesFirstEventId={Number(id)}
          openAddEvent={openAddEvent}
          setOpenAddEvent={setOpenAddEvent}
          index={events.length + 1}
          eventType={eventTypeSelected}
        ></AddNewSeriesEventCast>
      )}
    </>
  )
}
export default SeriesEvents
